// extracted by mini-css-extract-plugin
export default {"zitat":"Rezensionen_zitat__ELAgp","verweis":"Rezensionen_verweis__9EmHr"};